var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and allows selecting the damaged shutter type during the external damage declaration flow.
 * touches: declaration, externalDamage, shuttersDamage
 * invariants: The selected shutter type is synchronized with the shutter damage model through ShuttersComponent; displayed choices come from the shutter types configured in business constants.
 * inputs: shutterType, SHUTTER_TYPE_CHOICES, externalDamage state inherited from ShuttersComponent
 * outputs: updates shutterType through the inherited ShuttersComponent setter; displays validation errors associated with the shutterType field.
 * see: @declaration/components/externalDamage/ShuttersComponent, @declaration/constants/externalDamages, @shared/types/api/externalDamage
 */
import { Component } from 'vue-property-decorator';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import { ShuttersComponent } from './ShuttersComponent';
import { SHUTTER_SUBTITLE, SHUTTER_TITLE, SHUTTER_TYPE_CHOICES, } from '@declaration/constants/externalDamages';
let ShuttersType = class ShuttersType extends ShuttersComponent {
    get title() {
        return this.translateExternalDamageKey(SHUTTER_TITLE);
    }
    get subtitle() {
        return this.translateExternalDamageKey(SHUTTER_SUBTITLE);
    }
    get shutterTypeChoices() {
        return SHUTTER_TYPE_CHOICES.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
};
ShuttersType = __decorate([
    Component({ components: { UiRadio, UiCard } })
], ShuttersType);
export default ShuttersType;
